import type { CreatorCollection, CreatorProfile } from "./types";
import { normalizeCreatorHandle } from "./url";

// Build a compact avatar label from the creator's public name.
//
export function getProfileInitials(profile: CreatorProfile): string {
  const initials = profile.name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");

  return initials || profile.handle.slice(0, 2).toUpperCase() || "HF";
}

// Keep every internal profile link on the canonical unprefixed handle route.
//
export function getCreatorProfilePath(
  profile: CreatorProfile | string,
): string {
  const handle = typeof profile === "string" ? profile : profile.handle;
  return `/${normalizeCreatorHandle(handle)}`;
}

// Place collections underneath the creator so authorship stays in every URL.
//
export function getCreatorCollectionPath(
  profile: CreatorProfile | string,
  collection: CreatorCollection | string,
): string {
  const slug = typeof collection === "string" ? collection : collection.slug;
  return `${getCreatorProfilePath(profile)}/${slug}`;
}

// Link to the creator's actual X profile rather than simulating follow state.
//
export function getCreatorXUrl(profile: CreatorProfile): string {
  return `https://x.com/${normalizeCreatorHandle(profile.handle)}`;
}
